
export class WireCompanyAddressModel {
    preText: string;
    street: string;
    city: string;
    state: string;
    country: string;
    postalCode: string;

    constructor(apiModel?: WireCompanyAddressModel) {
        if (apiModel) {
            this.preText = apiModel.preText;
            this.street = apiModel.street;
            this.city = apiModel.city;
            this.state = apiModel.state;
            this.country = apiModel.country;
            this.postalCode = apiModel.postalCode;
        }
    }

    toApiModel(): WireCompanyAddressModel {
        return {
            preText: this.preText,
            street: this.street,
            city: this.city,
            state: this.state,
            country: this.country,
            postalCode: this.postalCode,
        } as WireCompanyAddressModel;
    }

    clone(): WireCompanyAddressModel {
        return new WireCompanyAddressModel(this.toApiModel());
    }

    equals(other: WireCompanyAddressModel): boolean {
        for (const field of Object.keys(this)) {
            if (this[field] !== other[field]) {
                return false;
            }
        }

        return true;
    }

    isFieldEmpty(): boolean {
        return !this.preText?.trim()
        && !this.street?.trim()
        && !this.city?.trim()
        && !this.state?.trim()
        && !this.country?.trim()
        && !this.postalCode?.trim();
    }
}
